var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5354 5.8L12.7278 7.99236C12.8201 8.08472 12.8201 8.23541 12.7278 8.32777L7.41944 13.6361L5.16389 13.8865C4.8625 13.9205 4.60729 13.6653 4.64132 13.3639L4.89167 11.1083L10.2 5.8C10.2924 5.70764 10.4431 5.70764 10.5354 5.8ZM14.4729 5.2434L13.2868 4.05729C12.9174 3.68784 12.317 3.68784 11.9451 4.05729L11.0847 4.9177C10.9924 5.01007 10.9924 5.16076 11.0847 5.25312L13.2771 7.44548C13.3694 7.53784 13.5201 7.53784 13.6125 7.44548L14.4729 6.58507C14.8424 6.21319 14.8424 5.61284 14.4729 5.2434ZM10.0833 12.1924V14.6667H2.30556V6.88889H7.89097C7.96875 6.88889 8.04167 6.85729 8.09757 6.80382L9.06979 5.83159C9.25451 5.64687 9.12326 5.33333 8.86319 5.33333H1.91667C1.27257 5.33333 0.75 5.8559 0.75 6.5V15.0556C0.75 15.6996 1.27257 16.2222 1.91667 16.2222H10.4722C11.1163 16.2222 11.6389 15.6996 11.6389 15.0556V11.2201C11.6389 10.9601 11.3253 10.8312 11.1406 11.0135L10.1684 11.9858C10.1149 12.0417 10.0833 12.1146 10.0833 12.1924Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.75 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.147823f443ebc8e12e7287b98b38801a.svg";
export { ForwardRef as ReactComponent };